module.exports = __webpack_public_path__ + "static/media/header.2251a5b1.png";